import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@klarna/bubble-ui';

export const ApplicantSelectorLabel = ({
  address: { city = '', postalCode = '', street = '' } = {},
  firstName,
  lastName,
}) => {
  const hasAddress = !!(street.length && postalCode.length && city.length);
  return (
    <Typography textToken="text-style/text/super-paragraphs/body/regular">
      {`${firstName} ${lastName}`}
      {hasAddress && `, ${street}, ${postalCode} ${city}`}
    </Typography>
  );
};

ApplicantSelectorLabel.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  address: PropTypes.shape({
    city: PropTypes.string,
    postalCode: PropTypes.string,
    street: PropTypes.string,
  }),
};
